<template>
  <responsive-drawer-header :color="theme.appBar.other.color" :moduleUnreadCount="unreadCount">
    <template v-slot:drawer-module-title> {{ mx_moduleTitle }}</template>
    <template v-slot:drawer-subtitle>
      {{ drawerSubtitle }}
    </template>

    <template v-slot:left-module-title>{{ contentTitle }}</template>
    <template v-slot:left-subtitle>{{ contentSubtitle }}</template>

    <template v-slot:right>
      <!-- Menu -->
      <v-menu v-if="userId" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" class="mr-2">{{ $t('bf.newAssessment') }}</v-btn>
        </template>
        <v-list class="py-0" v-if="showQuestionnaires">
          <v-divider />
          <v-list-item :class="listTitleClass">
            <v-list-item-title>{{ $t('bf.questionnaires') }}</v-list-item-title>
          </v-list-item>
          <v-divider />
          <template v-for="(item, i) in questionnaires">
            <v-list-item :key="i" :href="`/begleitfahrt/${mx_instance}/bewertung/${userId}/${item.id}/${randomUUID()}`">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
        <v-list class="py-0" v-if="showDiscussions">
          <v-list-item :class="listTitleClass">
            <v-list-item-title>{{ $t('bf.evaluations') }}</v-list-item-title>
          </v-list-item>
          <v-divider />
          <template v-for="(item, i) in discussions">
            <v-list-item :key="i" :href="`/begleitfahrt/${mx_instance}/bewertung/${userId}/${item.id}/${randomUUID()}`">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
        <v-list class="py-0" v-if="!showDiscussions && !showQuestionnaires">
          <v-list-item :class="listTitleClass">
            <v-list-item-title>{{ $t('bf.noAssesmentsAvailable') }}</v-list-item-title>
          </v-list-item>
        </v-list>

      </v-menu>
    </template>
  </responsive-drawer-header>
</template>

<script>
import common from '@/mixins/common';
import { mapState } from 'vuex';
import index from './index.js';
import configMixin from '@/mixins/configMixin';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';

export default {
  name: 'BegleitfahrtHeader',
  components: {
    ResponsiveDrawerHeader,
  },
  mixins: [common, configMixin],

  computed: {
    ...mapState('begleitfahrt', ['questionnaireById', 'unreadCount', 'userById']),
    moduleConfig() {
      return this.getModuleConfig(index.moduleType, 1);
    },
    discussions() {
      const today = new Date();
      return Object.values(this.questionnaireById)
          .filter((q) => q.isType === 'evaluation' && q.active === 1 && this.isValidDateRange(q, today))
          .sort((a, b) => a.sort - b.sort)
          .map((q) => ({ id: q.id, title: q.title }));
    },

    questionnaires() {
      const today = new Date();
      return Object.values(this.questionnaireById)
          .filter((q) => q.isType === 'questionnaire' && q.active === 1 && this.isValidDateRange(q, today))
          .sort((a, b) => a.sort - b.sort)
          .map((q) => ({ id: q.id, title: q.title }));
    },
    currentQuestionnaire() {
      return this.questionnaireById[this.$route.params.questionnaireId];
    },
    userId() {
      return this.$route.params.userId;
    },
    user() {
      return this.userById[this.userId];
    },
    drawerSubtitle() {
      switch (this.$route.name) {
        case 'begleitfahrt-main-page':
          return this.$t('bf.employees');
        case 'begleitfahrt-mitarbeiter':
          return this.$t('bf.employees');
      }
      return '';
    },
    contentTitle() {
      if (this.user && this.$route.name === 'begleitfahrt-mitarbeiter' ) {
        return this.$t('bf.assessments');
      }
      if (this.$route.name === 'begleitfahrt-main-page' ) {
        return this.$t('begleitfahrt.begleitfahrt');
      }
      return '';
    },
    contentSubtitle() {
      const firstName = this.user && this.user.firstname || ''
      const lastName = this.user && this.user.lastname || ''
      if (this.currentQuestionnaire && this.user) {
        return `${this.currentQuestionnaire.title}: ${firstName} ${lastName} `;
      }
      if (this.$route.name === 'begleitfahrt-main-page') {
        return this.$t('bf.overview');
      }
      if (this.$route.name === 'begleitfahrt-mitarbeiter' && this.user) {
        return `${firstName} ${lastName} `;
      }
      return '';
    },
    listTitleClass() {
      return this.darkMode ? 'grey darken-3 font-weight-medium' : 'grey lighten-3 font-weight-medium';
    },
    showDiscussions() {
      return this.moduleConfig.enableDiscussions && this.discussions.length > 0;
    },
    showQuestionnaires() {
      return this.questionnaires.length > 0;
    }
  },
  methods: {
    randomUUID() {
      return crypto.randomUUID();
    },
    /**
     * Check if the given date range is valid based on today's date.
     *
     * @param {Object} q - object containing 'anzeige_von' and 'anzeige_bis' properties
     * @param {Date} today - today's date
     * @return {Boolean} whether the date range is valid
     */
    isValidDateRange(q, today) {
      const startDate = new Date(q.anzeige_von);
      const endDate = new Date(q.anzeige_bis);

      if (q.anzeige_von && q.anzeige_bis) {
        return startDate <= today && today <= endDate;
      } else if (q.anzeige_von && !q.anzeige_bis) {
        return startDate <= today;
      } else if (!q.anzeige_von && q.anzeige_bis) {
        return today <= endDate;
      }
      return true;
    },
  },
};
</script>
